import axios from "axios";

export async function getQuestion(questionId) {
  return axios
    .get(`${import.meta.env.VITE_API_BASE_URL}/api/question/exercise/${questionId}`)
    .then((response) => response.data)
    .catch((err) => console.error(err));
}

export async function registerAnswer(questionId, answerId, origin, originId, courseId, questionStartTime) {
  return axios
    .post(`${import.meta.env.VITE_API_BASE_URL}/api/attempts/register`, {questionId: questionId, answerId: parseInt(answerId), origin: origin, originId: parseInt(originId), moduleId: courseId, startedAt: questionStartTime})
    .then((response) => response.data)
    .catch((err) => console.error(err));
}

/** For OPEN_ENDED questions: send text only (max 200 chars). No answerId. */
export async function registerOpenEndedAnswer(questionId, openEndedResponse, origin, originId, courseId, questionStartTime) {
  const trimmed = (openEndedResponse || "").trim().slice(0, 200);
  return axios
    .post(`${import.meta.env.VITE_API_BASE_URL}/api/attempts/register`, {
      questionId,
      origin,
      originId: parseInt(originId),
      moduleId: courseId,
      startedAt: questionStartTime,
      openEndedResponse: trimmed,
    }, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
    .then((response) => response.data)
    .catch((err) => console.error(err));
}

export async function getCurrentQuestionAnswer(questionId, origin, originId, courseId) {
  return axios
    .get(`${import.meta.env.VITE_API_BASE_URL}/api/attempts/getCurrent/${questionId}`,
      {params: {origin: origin, originId: parseInt(originId), moduleId: parseInt(courseId)}})
    .then((response) => response.data)
    .catch((err) => console.error(err));
}

export async function getPermitNextQuestion(questionId, origin, originId, courseId) {
  return axios
    .get(`${import.meta.env.VITE_API_BASE_URL}/api/attempts/permitNextQuestion/${questionId}`,
      {params: {origin: origin, originId: parseInt(originId), moduleId: parseInt(courseId)}})
    .then((response) => response.data)
    .catch((err) => console.error(err));
}
